export default "__VITE_ASSET__ijxYel62__"